import { memo } from "react";
import { useTranslation } from "react-i18next";
import Title from "@/components/Title";
import { QueryTable } from "@/components/query-table/QueryTable";
import { DataTableQueryContext } from "@/components/data-table/DataTableQueryContext";
import { costsReadSchema } from "@/schemas/costs";
import { useInvoiceSpecificationCostsQuery } from "../hooks/useInvoiceSpecificationCostsQuery";
import { useInvoiceSpecificationCostsList } from "../hooks/useInvoiceSpecificationCostsList";

interface InvoiceSpecificationCostsSectionProps {
  invoiceSpecificationId: string;
}

const InvoiceSpecificationCostsSectionComponent = ({
  invoiceSpecificationId,
}: InvoiceSpecificationCostsSectionProps) => {
  const { t } = useTranslation();

  const { options, tableFeatures, columnOverrides } =
    useInvoiceSpecificationCostsList(invoiceSpecificationId);

  const { query, queryValue } = useInvoiceSpecificationCostsQuery(
    invoiceSpecificationId,
    options,
  );

  return (
    <QueryTable
      schema={costsReadSchema}
      name={"costs"}
      query={query}
      options={options}
      tableFeatures={tableFeatures}
      columnOverrides={columnOverrides}
    >
      <div className="py-2">
        <Title>{t("costs.header")}</Title>
      </div>
      <div>
        <QueryTable.Menubar className="mb-2 grow">
          <QueryTable.Menubar.Tools />
          <QueryTable.Menubar.Columns />
          <QueryTable.Menubar.Reset />
        </QueryTable.Menubar>
        <DataTableQueryContext.Provider value={queryValue}>
          <QueryTable.Content />
        </DataTableQueryContext.Provider>
      </div>
    </QueryTable>
  );
};

export const InvoiceSpecificationCostsSection = memo(
  InvoiceSpecificationCostsSectionComponent,
);
